import type { Material } from "@/types/material";

/**
 * Narrow a list of ingredients to one concept. An ingredient with no concept is
 * shared across the organization — and every ingredient created before concept
 * scoping existed is one of those — so it stays on the list whichever concept
 * is selected. `null` means no concept was selected, so nothing is dropped.
 */
export function filterMaterialsByConcept<T extends Pick<Material, "companyId">>(
  materials: T[],
  companyId: number | null,
): T[] {
  if (companyId == null) return materials;
  return materials.filter((m) => m.companyId == null || m.companyId === companyId);
}
